import React from 'react'

const CareerCardSkeleton = () => {
  return (
    <section className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 px-6 md:px-10 py-16 gap-5">
      {[...Array(6)].map((_, index) => (
        <div
          key={index}
          className="bg-gradient-to-r from-[rgba(11,183,217,0.19)] via-white to-[#0bb7d931] rounded-md shadow-lg p-5 animate-pulse"
        >
          {/* Position & Job Type Skeleton */}
          <div className="flex justify-between items-start mb-4">
            <div className="space-y-2 flex-1">
              <div className="h-6 bg-gray-300 rounded w-3/4"></div>
              <div className="flex gap-2">
                <div className="h-5 bg-gray-300 rounded w-20"></div>
                <div className="h-5 bg-gray-300 rounded w-32"></div>
              </div>
            </div>
          </div>

          {/* Company Info Skeleton */}
          <div className="flex items-end justify-between gap-2">
            <div className="flex gap-2 items-end flex-1">
              <div className="h-12 w-12 bg-gray-300 rounded-md"></div>
              <div className="space-y-2 flex-1">
                <div className="h-5 bg-gray-300 rounded w-32"></div>
                <div className="flex items-center gap-1">
                  <div className="h-4 bg-gray-300 rounded w-24"></div>
                </div>
              </div>
            </div>
            <div className="h-6 w-6 bg-gray-300 rounded"></div>
          </div>
        </div>
      ))}
    </section>
  )
}

export default CareerCardSkeleton